<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('shippers.shippersLabel') }}</span>
        <h3 class="page-title">{{ $t('shippers.addingNewShipper') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/spedytorzy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>
        <d-button theme="success" @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('shippers.addNewShipper') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab
            :title="$t('ui.generalInfo')"
            active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ $t('ui.generalInfo') }}
            </h4>

            <validation-observer ref="shipper-new-form" tag="form">
              <div class="form-group">
                <label for="name">
                  {{ $t('shippers.shipperName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="name" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="name">
                  {{ $t('ui.code') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="code"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="code" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </validation-observer>
          </d-tab>

          <d-tab :title="$t('price.prices')">
            <p class="text-center">{{ $t('shippers.addingPricesWillBeAvailableAfterShipperSave') }}</p>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'shipper-new',
  data() {
    return {
      name: '',
      code: ''
    };
  },
  methods: {
    validateForm () {
      FormUtils.validate(this.$refs['shipper-new-form'], this.submitForm);
    },
    submitForm () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/shippers/store',
        formData: {
          name: this.name,
          code: this.code
        },
        successTitle: this.$t('shippers.addShipperSuccessTitle'),
        successText: this.$t('shippers.addShipperSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('shippers.addShipperErrorText'),
        successAction: (response) => {
          this.$router.push('/spedytorzy/edycja/' + response.id)
        }
      });
    }
  }
};
</script>
